var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g, _path75, _path76, _path77, _path78, _path79, _g2, _path80, _path81, _path82, _path83, _path84, _g3, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g4, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 307,
    viewBox: "0 0 282 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.927 52.7203C279.116 53.1074 278.256 53.5375 277.297 54.0228C276.978 54.1887 276.615 54.2502 276.253 54.2256C275.509 54.1765 274.76 53.7587 274.323 53.0705C273.666 52.0445 273.961 50.8095 274.95 50.2934C276.068 49.7159 277.094 49.2305 278.041 48.739C280.203 47.6146 282.354 51.5468 279.927 52.7203Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.297 54.0285C274.188 55.6137 271.466 56.136 269.187 56.1114C266.6 56.0807 264.597 55.3556 263.338 54.7105C259.848 52.9288 257.439 49.4943 257.439 46.029C257.439 43.467 258.76 41.2551 261.009 39.9648C261.783 41.2121 262.17 41.8511 262.963 43.1352C261.857 43.7741 261.605 44.8801 261.593 45.7034C261.574 47.4237 262.717 49.826 265.199 51.1163C267.89 52.5233 271.239 52.2161 274.95 50.293C275.847 51.7553 276.314 52.4987 277.303 54.0224L277.297 54.0285Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.771 55.1157C272.701 55.853 270.827 56.1233 269.186 56.1049C266.6 56.0742 264.597 55.3492 263.337 54.704C262.625 54.3415 261.961 53.9053 261.347 53.4199C261.912 51.6996 262.219 50.8456 262.864 49.1621C263.442 49.9117 264.21 50.5998 265.193 51.1159C267.884 52.5229 271.232 52.2157 274.943 50.2926C274.943 50.2926 275.705 52.3755 274.765 55.1095L274.771 55.1157Z",
    fill: "#1E1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.95 50.2926C271.239 52.2095 267.891 52.5229 265.2 51.1159C262.717 49.8195 261.575 47.4172 261.593 45.703C261.599 44.8858 261.857 43.7737 262.963 43.1348",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.009 39.9648C258.754 41.2551 257.439 43.467 257.439 46.029C257.439 49.4943 259.854 52.9349 263.338 54.7105C264.597 55.3556 266.6 56.0807 269.187 56.1114C271.466 56.136 274.188 55.6137 277.297 54.0285",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262.957 43.1347C264.007 42.5264 265.23 42.9688 265.857 43.2883C267.694 44.2283 269.5 46.6491 269.555 49.4016C269.605 51.8224 268.234 53.9666 265.525 55.6685C266.483 57.0817 266.981 57.8005 268.019 59.2628C271.89 56.842 273.838 53.4136 273.746 49.4876C273.653 45.5554 271.558 41.6601 268.155 39.8906C265.808 38.668 263.172 38.7171 261.003 39.9582C261.777 41.2055 262.164 41.8444 262.957 43.1285V43.1347Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.025 59.2686C271.896 56.8479 273.844 53.4195 273.752 49.4935C273.659 45.5613 271.564 41.666 268.16 39.8965C265.813 38.6738 263.178 38.723 261.009 39.9641",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.957 43.1352C264.008 42.527 265.23 42.9693 265.857 43.2888C267.694 44.2289 269.5 46.6496 269.556 49.4022C269.605 51.8229 268.235 53.9672 265.525 55.6691",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.026 59.2685C265.083 61.1056 262.459 61.8244 260.229 61.9535C257.698 62.1009 255.689 61.4927 254.411 60.9213C250.878 59.3361 248.254 55.9815 248.008 52.4548C247.824 49.8497 248.973 47.5273 251.111 46.0957C251.971 47.3245 252.401 47.9451 253.274 49.2107C252.223 49.9234 252.051 51.0662 252.1 51.8957C252.199 53.6406 253.495 56.0122 256.02 57.1672C258.761 58.4206 262.017 57.88 265.531 55.6742C266.49 57.0874 266.987 57.8062 268.026 59.2685Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.623 60.5522C263.645 61.4492 261.833 61.8548 260.229 61.9531C257.698 62.1005 255.689 61.4923 254.411 60.9209C253.692 60.5952 253.01 60.1959 252.377 59.7412C252.832 57.9656 253.077 57.0808 253.6 55.3359C254.214 56.0609 255.019 56.7122 256.02 57.173C258.754 58.4264 262.017 57.8857 265.531 55.68C265.531 55.68 266.398 57.726 265.623 60.5645V60.5522Z",
    fill: "#1E1D1D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.531 55.6686C262.017 57.8743 258.76 58.415 256.02 57.1616C253.495 56.0065 252.205 53.6349 252.1 51.89C252.051 51.0606 252.223 49.9178 253.274 49.2051",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M251.117 46.0957C248.979 47.5273 247.836 49.8497 248.014 52.4548C248.26 55.9815 250.877 59.3361 254.416 60.9213C255.694 61.4927 257.703 62.1009 260.235 61.9535C262.465 61.8244 265.089 61.1056 268.031 59.2685",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.28 49.2103C254.275 48.5344 255.516 48.9092 256.161 49.198C258.041 50.0397 259.983 52.3683 260.21 55.1454C260.413 57.5907 259.19 59.8579 256.628 61.7564C257.648 63.1265 258.176 63.8208 259.264 65.2278C262.926 62.5183 264.64 58.9056 264.32 54.9488C263.995 50.9798 261.678 47.2012 258.189 45.616C255.78 44.5224 253.175 44.719 251.123 46.0952C251.983 47.324 252.413 47.9446 253.286 49.2103H253.28Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.258 65.2278C262.92 62.5183 264.634 58.9056 264.315 54.9488C263.989 50.9798 261.673 47.2012 258.183 45.616C255.774 44.5224 253.169 44.719 251.117 46.0952",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.28 49.2119C254.276 48.536 255.517 48.9108 256.162 49.1996C258.042 50.0413 259.983 52.3699 260.211 55.147C260.413 57.5923 259.191 59.8595 256.629 61.758",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M259.258 65.2285C256.481 67.2867 253.943 68.1776 251.762 68.4418C249.286 68.7428 247.271 68.239 245.981 67.7291C242.399 66.3159 239.591 63.035 239.106 59.4592C238.749 56.8173 239.72 54.3965 241.741 52.8359C242.688 54.0525 243.155 54.6607 244.107 55.9018C243.118 56.6821 243.026 57.8495 243.13 58.6912C243.345 60.4607 244.783 62.8016 247.351 63.8338C250.134 64.952 253.305 64.2085 256.628 61.7509C257.648 63.1211 258.177 63.8153 259.264 65.2223L259.258 65.2285Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.979 66.6915C255.087 67.7298 253.336 68.2521 251.763 68.4425C249.287 68.7436 247.272 68.2398 245.981 67.7298C245.25 67.441 244.556 67.0724 243.898 66.6423C244.243 64.8175 244.427 63.9082 244.838 62.108C245.496 62.8146 246.331 63.429 247.345 63.8406C250.128 64.9589 253.299 64.2154 256.623 61.7578C256.623 61.7578 257.587 63.7731 256.979 66.6915Z",
    fill: "#1E1D1D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.622 61.7515C253.298 64.2152 250.128 64.9525 247.344 63.8343C244.782 62.8021 243.345 60.4612 243.123 58.6917C243.019 57.85 243.111 56.6826 244.1 55.9023",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.741 52.8359C239.72 54.3965 238.743 56.8173 239.106 59.4592C239.591 63.035 242.405 66.3159 245.981 67.7291C247.277 68.239 249.286 68.7428 251.762 68.4418C253.943 68.1776 256.481 67.2806 259.258 65.2285",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M244.113 55.9088C245.053 55.1716 246.306 55.4849 246.969 55.743C248.893 56.4987 250.963 58.7474 251.356 61.5491C251.7 64.019 250.625 66.3844 248.211 68.4488C249.292 69.7759 249.845 70.4456 250.982 71.8096C254.441 68.8543 255.946 65.0819 255.393 61.0944C254.84 57.1008 252.296 53.4082 248.727 51.9889C246.263 51.0059 243.689 51.3315 241.747 52.8307C242.693 54.0472 243.16 54.6555 244.113 55.8966V55.9088Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250.976 71.8096C254.435 68.8543 255.94 65.0819 255.387 61.0944C254.834 57.1008 252.291 53.4082 248.721 51.9889C246.257 51.0059 243.683 51.3315 241.741 52.8307",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M244.113 55.9074C245.053 55.1701 246.307 55.4835 246.97 55.7415C248.893 56.4972 250.964 58.7459 251.357 61.5476C251.701 64.0175 250.626 66.383 248.211 68.4474",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250.976 71.809C248.346 74.0516 245.901 75.0961 243.763 75.477C241.336 75.9132 239.327 75.5016 238.024 75.0469C234.411 73.7935 231.425 70.5802 230.713 66.9675C230.184 64.2948 230.989 61.7942 232.894 60.123C233.914 61.3211 234.424 61.9294 235.456 63.1521C234.522 63.9876 234.51 65.1796 234.663 66.0275C234.995 67.8154 236.562 70.1317 239.161 71.0533C241.975 72.0486 245.065 71.1332 248.205 68.4544C249.286 69.7815 249.839 70.4512 250.976 71.8151V71.809Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M248.807 73.4256C247.001 74.5807 245.299 75.2074 243.763 75.4839C241.336 75.9201 239.327 75.5084 238.018 75.0538C237.281 74.7957 236.574 74.4578 235.898 74.0523C236.138 72.1906 236.273 71.2629 236.568 69.4197C237.262 70.1017 238.123 70.6915 239.155 71.054C241.969 72.0493 245.059 71.1339 248.199 68.4551C248.199 68.4551 249.262 70.4396 248.801 73.4256H248.807Z",
    fill: "#1E1D1D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.205 68.4546C245.066 71.1334 241.975 72.0489 239.161 71.0536C236.569 70.132 234.996 67.8157 234.664 66.0277C234.504 65.1737 234.523 63.9879 235.457 63.1523",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M232.894 60.123C230.989 61.7942 230.184 64.2948 230.713 66.9675C231.425 70.5863 234.405 73.7935 238.024 75.0469C239.333 75.5016 241.342 75.9132 243.763 75.477C245.901 75.0899 248.346 74.0516 250.976 71.809",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M235.456 63.1521C236.346 62.3595 237.612 62.6237 238.282 62.8572C240.242 63.533 242.441 65.7203 242.994 68.5342C243.48 71.0164 242.54 73.4679 240.26 75.6736C241.391 76.9577 241.968 77.609 243.142 78.9238C246.417 75.7658 247.719 71.8643 246.951 67.8584C246.183 63.8464 243.418 60.2398 239.781 58.9618C237.268 58.0771 234.731 58.5133 232.894 60.1231C233.913 61.3212 234.423 61.9294 235.456 63.1521Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.142 78.918C246.417 75.7599 247.719 71.8585 246.951 67.8526C246.183 63.8405 243.418 60.2339 239.781 58.956C237.268 58.0712 234.731 58.5075 232.894 60.1172",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M235.456 63.1515C236.347 62.3589 237.613 62.6231 238.282 62.8565C240.242 63.5324 242.442 65.7197 242.995 68.5336C243.48 71.0158 242.54 73.4673 240.261 75.673",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M243.142 78.9181C240.66 81.3142 238.288 82.4816 236.199 82.967C233.827 83.52 231.825 83.1943 230.51 82.7888C226.879 81.6767 223.751 78.5433 222.83 74.8999C222.148 72.2088 222.793 69.6406 224.575 67.8711C225.668 69.0569 226.215 69.6529 227.309 70.8571C226.43 71.7418 226.491 72.9461 226.694 73.8062C227.124 75.6064 228.814 77.892 231.437 78.7092C234.276 79.6001 237.287 78.5371 240.248 75.674C241.378 76.9581 241.956 77.6094 243.13 78.9242L243.142 78.9181Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.078 80.6566C239.352 81.9162 237.699 82.6227 236.2 82.9729C233.828 83.5259 231.825 83.2003 230.51 82.7948C229.767 82.5674 229.054 82.2541 228.366 81.867C228.514 79.9808 228.594 79.0407 228.79 77.1607C229.515 77.8242 230.4 78.3833 231.438 78.709C234.277 79.5999 237.287 78.5369 240.249 75.6738C240.249 75.6738 241.398 77.6276 241.072 80.6566H241.078Z",
    fill: "#1E1D1D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M240.26 75.6743C237.299 78.5375 234.288 79.6004 231.45 78.7095C228.832 77.8923 227.143 75.6068 226.707 73.8066C226.498 72.9464 226.442 71.7422 227.321 70.8574",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M224.581 67.877C222.793 69.6464 222.154 72.2146 222.836 74.9057C223.758 78.5491 226.885 81.6826 230.516 82.7947C231.831 83.194 233.834 83.5258 236.206 82.9728C238.295 82.4875 240.66 81.3201 243.149 78.9239",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M227.321 70.8575C228.157 70.0219 229.428 70.2431 230.11 70.452C232.101 71.0602 234.417 73.1799 235.112 76C235.72 78.4884 234.909 81.0013 232.752 83.3237C233.926 84.5648 234.522 85.1915 235.732 86.4572C238.829 83.1333 239.959 79.1458 238.995 75.1337C238.03 71.1155 235.063 67.5889 231.358 66.4338C228.802 65.6351 226.301 66.1696 224.587 67.8715C225.681 69.0573 226.227 69.6533 227.321 70.8575Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M235.732 86.4572C238.829 83.1333 239.959 79.1458 238.995 75.1337C238.03 71.1155 235.063 67.5889 231.358 66.4338C228.802 65.6351 226.301 66.1696 224.587 67.8715",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.321 70.8574C228.157 70.0218 229.429 70.2429 230.111 70.4518C232.101 71.0601 234.418 73.1798 235.112 75.9999C235.72 78.4882 234.909 81.0011 232.753 83.3236",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M235.732 86.4563C233.379 88.9753 231.093 90.2472 229.054 90.8186C226.737 91.4698 224.753 91.2179 223.444 90.8616C219.813 89.8785 216.581 86.8311 215.475 83.1815C214.658 80.4843 215.144 77.8608 216.809 76.0176C217.964 77.1911 218.541 77.7748 219.696 78.9544C218.873 79.876 219.002 81.0926 219.248 81.9527C219.776 83.7529 221.558 86.0016 224.188 86.7266C227.038 87.5131 229.963 86.3273 232.758 83.3228C233.932 84.5639 234.528 85.1906 235.738 86.4563H235.732Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.767 88.2869C232.114 89.6263 230.516 90.4066 229.054 90.8121C226.738 91.4634 224.753 91.2115 223.445 90.8551C222.701 90.6524 221.982 90.3636 221.288 90.0011C221.35 88.1087 221.386 87.1564 221.491 85.2579C222.24 85.903 223.144 86.4314 224.182 86.7202C227.033 87.5066 229.957 86.3208 232.753 83.3164C232.753 83.3164 233.976 85.2333 233.767 88.2808V88.2869Z",
    fill: "#1E1D1D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M232.753 83.3235C229.957 86.3341 227.033 87.5199 224.182 86.7273C221.559 86.0023 219.771 83.7536 219.242 81.9534C218.99 81.0932 218.867 79.8767 219.691 78.9551",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M216.803 76.0117C215.138 77.8611 214.652 80.4784 215.469 83.1757C216.575 86.8252 219.813 89.8727 223.438 90.8557C224.747 91.2121 226.738 91.464 229.048 90.8127C231.088 90.2413 233.373 88.9756 235.726 86.4504",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M219.691 78.9551C220.471 78.0826 221.749 78.2608 222.437 78.4513C224.446 78.9981 226.861 81.0563 227.678 83.8703C228.397 86.3463 227.696 88.9084 225.663 91.3107C226.867 92.5088 227.475 93.1109 228.698 94.3274C231.635 90.8868 232.605 86.8379 231.469 82.8381C230.326 78.8322 227.18 75.3854 223.432 74.3409C220.846 73.622 218.4 74.2365 216.797 76.0182C217.952 77.1917 218.53 77.7754 219.685 78.9551H219.691Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M228.704 94.3216C231.641 90.8809 232.611 86.832 231.475 82.8322C230.332 78.8263 227.186 75.3795 223.438 74.335C220.852 73.6162 218.406 74.2306 216.803 76.0124",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M219.69 78.9553C220.471 78.0829 221.749 78.261 222.437 78.4515C224.446 78.9983 226.861 81.0566 227.678 83.8705C228.397 86.3466 227.696 88.9086 225.662 91.3109",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M228.704 94.3199C226.473 96.9311 224.262 98.2766 222.277 98.9218C220.022 99.6529 218.068 99.4686 216.766 99.1552C213.166 98.2951 209.866 95.3459 208.607 91.7148C207.673 89.0299 208.017 86.3756 209.559 84.4648C210.757 85.6138 211.359 86.1913 212.563 87.3464C211.802 88.2987 211.98 89.5214 212.268 90.3754C212.871 92.1695 214.732 94.369 217.343 95.008C220.182 95.7023 223.021 94.4182 225.656 91.297C226.861 92.4951 227.469 93.0972 228.691 94.3137L228.704 94.3199Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M222.363 94.1862C223.488 93.535 224.588 92.5704 225.663 91.3047C225.663 91.3047 226.941 93.1786 226.83 96.226C225.245 97.6207 223.703 98.4563 222.277 98.9233C222.302 97.0371 222.314 96.0909 222.363 94.1924V94.1862Z",
    fill: "#1E1D1D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M225.663 91.3041C223.021 94.4253 220.182 95.7094 217.35 95.0151C214.733 94.3761 212.877 92.1766 212.275 90.3825C211.986 89.5285 211.808 88.3058 212.57 87.3535",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M209.565 84.4648C208.017 86.3695 207.679 89.0299 208.613 91.7148C209.873 95.3521 213.172 98.2951 216.772 99.1552C218.075 99.4686 220.029 99.6468 222.284 98.9218C224.268 98.2766 226.48 96.9311 228.71 94.3199",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M212.57 87.3527C213.295 86.4495 214.566 86.5969 215.261 86.7628C217.276 87.2544 219.764 89.245 220.686 92.0344C221.497 94.492 220.895 97.0664 218.972 99.5301C220.194 100.685 220.809 101.257 222.031 102.412C224.827 98.8973 225.669 94.8238 224.391 90.867C223.107 86.898 219.807 83.5372 216.041 82.591C213.442 81.9398 211.058 82.634 209.571 84.465C210.769 85.6139 211.371 86.1914 212.576 87.3465L212.57 87.3527Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M222.026 102.412C224.821 98.8973 225.663 94.8238 224.385 90.867C223.101 86.898 219.801 83.5372 216.035 82.591C213.436 81.9398 211.052 82.634 209.565 84.465",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M212.569 87.353C213.294 86.4498 214.566 86.5973 215.26 86.7632C217.276 87.2547 219.764 89.2454 220.686 92.0348C221.497 94.4924 220.882 97.0544 218.959 99.512",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.859 269.669C84.3923 288.04 28.586 262.014 10.2215 211.547C-8.14914 161.079 17.877 105.273 68.3441 86.9087L143.252 59.6414C193.719 41.2708 249.525 67.2969 267.89 117.764C286.261 168.231 260.235 224.037 209.767 242.402L134.859 269.669Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M255.252 256.134C262.523 256.134 268.418 250.239 268.418 242.967C268.418 235.696 262.523 229.801 255.252 229.801C247.98 229.801 242.085 235.696 242.085 242.967C242.085 250.239 247.98 256.134 255.252 256.134Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M267.19 230.433C273.776 241.843 255.215 260.392 242.589 254.027C242.589 254.027 216.747 233.997 216.723 233.966L252.094 205.354L267.196 230.433H267.19Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M259.245 247.501C259.989 246.837 260.695 246.13 261.353 245.381C262.201 244.41 262.962 243.366 263.614 242.254C265.113 239.698 266.188 236.503 265.334 233.554C265.027 232.491 264.468 231.661 263.909 230.727C263.227 229.591 262.538 228.454 261.856 227.317C259.522 223.434 257.181 219.551 254.846 215.668C253.666 213.715 252.487 211.755 251.313 209.801L221.767 234.014L230.626 240.957C236.924 239.636 244.18 235.858 259.251 247.507L259.245 247.501Z",
    fill: "#9583FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9469 272.427C39.2187 272.427 45.1136 266.532 45.1136 259.26C45.1136 251.989 39.2187 246.094 31.9469 246.094C24.6752 246.094 18.7803 251.989 18.7803 259.26C18.7803 266.532 24.6752 272.427 31.9469 272.427Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1997 249.584C16.8574 253.412 19.6099 261.288 26.356 267.181C32.5369 272.581 39.9282 274.437 43.6884 271.752L64.7747 260.103L30.0363 234.574L20.1997 249.584Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.608 251.685C21.2686 253.282 22.2086 255.998 22.9459 257.638L23.5541 258.848C25.5817 262.486 28.795 265.539 32.3954 267.591C34.171 268.605 36.1248 269.416 38.1647 269.693C39.0863 269.816 40.0509 269.834 40.9479 269.57C41.5316 269.398 42.0047 269.035 42.5331 268.747L58.8639 259.721L30.8594 239.145L25.5387 247.261L22.608 251.685Z",
    fill: "#9583FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M240.856 127.601C222.486 77.1338 178.783 46.7086 143.246 59.6418L68.3379 86.909L134.859 269.669L209.767 242.402C245.304 229.469 259.227 178.068 240.856 127.601Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M164.768 98.5562L165.841 97.6367L164.921 96.5636L163.848 97.4831L164.768 98.5562Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M146.022 90.4997L147.403 89.3164L146.22 87.9354L144.839 89.1186L146.022 90.4997Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M166.495 131.98L167.876 130.797L166.693 129.416L165.312 130.599L166.495 131.98Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M168.091 126.553L168.977 126.76L169.183 125.874L168.298 125.667L168.091 126.553Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M235.505 101.345L236.146 101.494L236.295 100.854L235.655 100.704L235.505 101.345Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M150.901 92.1125L152.093 92.1094L152.09 90.9174L150.898 90.9206L150.901 92.1125Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M207.325 217.306L208.398 216.387L207.479 215.314L206.406 216.233L207.325 217.306Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M198.696 179.076L200.077 177.893L198.894 176.512L197.513 177.695L198.696 179.076Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M201.899 182.927L203.091 182.924L203.088 181.732L201.896 181.735L201.899 182.927Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M220.253 120.999L221.445 120.996L221.442 119.804L220.25 119.807L220.253 120.999Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M183.28 115.796L184.472 115.793L184.469 114.601L183.277 114.604L183.28 115.796Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M177.864 128.925L179.056 128.922L179.053 127.73L177.861 127.733L177.864 128.925Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M169.534 114.329L170.726 114.326L170.722 113.134L169.531 113.137L169.534 114.329Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M178.693 79.7434L179.885 79.7402L179.882 78.5483L178.69 78.5514L178.693 79.7434Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M205.118 98.0033C219.601 94.2228 230.139 86.5536 228.656 80.8735C227.174 75.1936 214.231 73.6537 199.749 77.4342C185.267 81.2146 174.728 88.8838 176.211 94.5638C177.694 100.244 190.636 101.784 205.118 98.0033Z",
    fill: "#F6F3EF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8467_88027)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8467_88027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 77,
    width: 40,
    height: 23
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M202.459 77.707L220.957 87.7453L197.307 99.2111L181.021 86.9637L202.459 77.707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8467_88027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.941 88.9783C211.948 87.7962 210.981 86.4978 209.099 85.2446L212.027 83.8493L210.435 83.0031L207.605 84.3403C207.197 84.1142 206.776 83.8945 206.361 83.6685L209.198 82.3378L207.671 81.5303L204.802 82.861C204.473 82.6866 204.15 82.5186 203.848 82.3507H203.854L201.867 81.2461L199.998 82.0923C199.998 82.0923 201.071 82.6737 201.031 82.6737C201.61 83.0031 201.387 83.3067 201.077 83.5005L197.708 85.0508C197.748 85.0767 197.8 85.109 197.846 85.1477C197.8 85.1219 197.748 85.0896 197.695 85.0573L192.865 87.2859C192.602 87.3827 192.122 87.4861 191.733 87.2342C191.733 87.2536 190.753 86.5947 190.753 86.5947L188.259 87.4344L189.996 88.6101C190.325 88.8362 190.641 89.0558 190.963 89.2754L187.759 90.7611L189.128 91.7301L192.326 90.2314C192.701 90.5027 193.076 90.7611 193.451 91.0131L190.246 92.5246L191.681 93.5452L194.958 91.982C197.689 93.6098 200.38 94.4367 203.736 93.0608C206.401 91.9626 206.506 90.8257 205.394 89.6759C206.888 89.9666 208.467 89.8439 209.954 88.9654L209.941 88.9783ZM200.959 90.8839C198.557 92.0466 195.649 89.8245 194.668 89.185L198.807 87.2471C199.807 87.8672 203.433 89.6888 200.959 90.8839ZM206.085 87.6218C203.979 88.6295 201.505 86.8789 200.663 86.375L204.289 84.6762C205.144 85.1671 208.243 86.5818 206.079 87.6218H206.085Z",
    fill: "#1E1D1D"
  })))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M205.117 98.0104C219.598 94.2318 230.135 86.5641 228.654 80.8809L230.559 88.18C232.04 93.8571 221.503 101.531 207.021 105.31C192.54 109.088 179.594 107.552 178.114 101.869L176.209 94.5698C177.69 100.247 190.635 101.789 205.117 98.0104Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M208.595 97.0025C210.61 96.3635 212.527 95.6508 214.315 94.8828L216.219 102.182C214.425 102.95 212.515 103.663 210.499 104.302L208.595 97.0025Z",
    fill: "#4D99FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M216.883 93.7084C221.221 91.5765 224.63 89.1434 226.67 86.7227L228.575 94.0218C226.535 96.4425 223.125 98.8756 218.787 101.008L216.883 93.7084Z",
    fill: "#1E1D1D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M205.117 98.0104C219.598 94.2318 230.135 86.5641 228.654 80.8809L230.559 88.18C232.04 93.8571 221.503 101.531 207.021 105.31C192.54 109.088 179.594 107.552 178.114 101.869L176.209 94.5698C177.69 100.247 190.635 101.789 205.117 98.0104Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M191.641 201.435C197.09 187.495 197.075 174.461 191.608 172.324C186.14 170.187 177.29 179.756 171.841 193.696C166.392 207.636 166.407 220.67 171.874 222.807C177.342 224.944 186.192 215.376 191.641 201.435Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8467_88027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.304 198.226C184.211 198.251 183.745 198.389 182.7 198.618C181.828 198.805 181.197 198.911 180.968 198.947C177.126 199.586 173.953 199.449 174.228 198.419C174.503 197.388 178.112 196.019 182.046 195.28L181.193 198.22C181.421 198.193 182.064 198.11 182.934 197.931C183.934 197.729 184.432 197.58 184.524 197.555L185.349 194.838C188.105 194.618 189.765 194.979 189.526 195.722C189.287 196.464 187.211 197.462 184.319 198.24L184.304 198.226ZM185.425 194.541L186.182 192.045L189.954 191.791L191.081 188.27L178.643 187.854L177.352 192.645L182.908 192.265L182.118 194.963C177.625 195.789 173.337 197.49 172.984 198.864C172.632 200.23 176.351 200.44 180.758 199.65L178.446 207.587L181.852 206.261L184.108 198.875C187.362 197.951 189.712 196.708 190.02 195.772C190.328 194.836 188.526 194.324 185.436 194.534L185.425 194.541Z",
    fill: "#1E1D1D"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M171.847 193.717C166.397 207.658 166.409 220.689 171.877 222.827L164.855 220.081C159.387 217.943 159.374 204.911 164.824 190.97C170.274 177.03 179.121 167.463 184.589 169.602L191.612 172.348C186.144 170.21 177.296 179.782 171.847 193.717Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M170.618 197.127C169.955 199.136 169.402 201.102 168.972 203.001L161.949 200.255C162.379 198.356 162.932 196.384 163.596 194.381L170.618 197.127Z",
    fill: "#4D99FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M168.418 205.766C167.595 210.528 167.558 214.718 168.32 217.79L161.297 215.043C160.535 211.971 160.572 207.781 161.396 203.02L168.418 205.766Z",
    fill: "#1E1D1D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M171.847 193.717C166.397 207.658 166.409 220.689 171.877 222.827L164.855 220.081C159.387 217.943 159.374 204.911 164.824 190.97C170.274 177.03 179.121 167.463 184.589 169.602L191.612 172.348C186.144 170.21 177.296 179.782 171.847 193.717Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M246.389 195.029C257.014 184.486 259.575 169.841 252.111 162.319C244.646 154.797 229.982 157.246 219.358 167.789C208.734 178.332 206.172 192.977 213.637 200.499C221.101 208.021 235.765 205.572 246.389 195.029Z",
    fill: "#F6F3EF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8467_88027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.401 175.013L242.202 169.494L242.015 188.32L228.845 185.562L224.401 175.013ZM222.288 193.445L223.279 176.281L227.64 187.01L240.806 189.895L222.287 193.451L222.288 193.445Z",
    fill: "#9583FF"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M246.386 195.007C257.009 184.464 259.571 169.823 252.106 162.303L255.959 166.186C263.424 173.706 260.862 188.353 250.239 198.897C239.616 209.44 224.95 211.891 217.491 204.371L213.639 200.488C221.104 208.008 235.763 205.557 246.386 195.014V195.007Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M248.837 192.328C250.195 190.7 251.374 189.004 252.376 187.277L256.228 191.16C255.227 192.887 254.047 194.583 252.689 196.211L248.837 192.328Z",
    fill: "#4D99FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M253.722 184.691C255.854 180.12 256.732 175.445 256.247 171.285L260.099 175.168C260.591 179.328 259.706 184.003 257.574 188.574L253.722 184.691Z",
    fill: "#1E1D1D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M246.386 195.007C257.009 184.464 259.571 169.823 252.106 162.303L255.959 166.186C263.424 173.706 260.862 188.353 250.239 198.897C239.616 209.44 224.95 211.891 217.491 204.371L213.639 200.488C221.104 208.008 235.763 205.557 246.386 195.014V195.007Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M176.709 249.318C185.318 243.138 185.222 228.272 176.494 216.112C167.766 203.952 153.712 199.105 145.103 205.284C136.494 211.463 136.59 226.33 145.318 238.489C154.046 250.649 168.1 255.497 176.709 249.318Z",
    fill: "#B3D3FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M145.316 238.507C154.041 250.666 168.098 255.514 176.706 249.339L172.264 252.528C163.656 258.709 149.605 253.855 140.874 241.696C132.15 229.537 132.051 214.668 140.659 208.493L145.101 205.305C136.494 211.486 136.592 226.348 145.316 238.507Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M147.571 241.346C148.966 242.943 150.453 244.381 152.001 245.64L147.559 248.829C146.01 247.57 144.524 246.132 143.129 244.534L147.571 241.346Z",
    fill: "#4D99FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M154.337 247.385C158.515 250.217 162.987 251.827 167.178 251.999L162.729 255.188C158.545 255.01 154.066 253.4 149.895 250.568L154.337 247.379V247.385Z",
    fill: "#1E1D1D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M145.316 238.507C154.041 250.666 168.098 255.514 176.706 249.339L172.264 252.528C163.656 258.709 149.605 253.855 140.874 241.696C132.15 229.537 132.051 214.668 140.659 208.493L145.101 205.305C136.494 211.486 136.592 226.348 145.316 238.507Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M267.89 117.764C249.519 67.2964 193.719 41.2764 143.252 59.6409C178.789 46.7078 222.492 77.133 240.862 127.6C259.233 178.067 245.311 229.468 209.773 242.401C260.241 224.031 286.26 168.231 267.896 117.764H267.89Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M258.625 178.363C255.203 185.705 250.822 192.593 245.588 198.841C243.05 208.309 239.118 216.806 233.914 223.872C245.434 214.797 254.49 203.203 260.548 190.209C264.776 181.146 267.54 171.408 268.677 161.369C269.826 151.206 269.298 140.737 266.914 130.354C268.523 147.059 265.501 163.605 258.625 178.357V178.363Z",
    fill: "#9583FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M267.89 117.764C249.519 67.2964 193.719 41.2764 143.252 59.6409C178.789 46.7078 222.492 77.133 240.862 127.6C259.233 178.067 245.311 229.468 209.773 242.401C260.241 224.031 286.26 168.231 267.896 117.764H267.89Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M165.948 154.861C147.577 104.394 103.875 73.9683 68.3377 86.9015C17.8706 105.272 -8.14935 161.072 10.2152 211.539C28.5858 262.007 84.3859 288.027 134.853 269.662C170.39 256.729 184.312 205.328 165.942 154.861H165.948Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M122.535 306.195C129.807 306.195 135.701 300.3 135.701 293.028C135.701 285.756 129.807 279.861 122.535 279.861C115.263 279.861 109.368 285.756 109.368 293.028C109.368 300.3 115.263 306.195 122.535 306.195Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M139.056 268.011L138.995 292.433C138.989 295.647 132.451 299.271 123.96 300.672C115.592 302.055 108.33 300.783 107.12 297.84L97.6885 274.874C97.6762 274.837 97.664 274.806 97.6578 274.769C97.3752 273.073 106.413 270.173 117.847 268.281C129.275 266.395 138.768 266.235 139.044 267.931C139.044 267.955 139.05 267.98 139.05 268.011H139.056Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5576 175.132C16.4148 174.53 15.782 173.27 15.9848 171.992C16.9002 166.278 18.9278 156.134 23.8368 144.049C24.2915 142.937 25.5387 142.378 26.6692 142.789L29.7781 143.92C30.3249 144.123 30.7734 144.534 31.0069 145.069C31.2404 145.603 31.2527 146.212 31.0253 146.752C28.193 153.585 24.6171 163.999 22.6387 175.531C22.393 176.975 20.685 177.626 19.536 176.711L17.5576 175.126V175.132Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1656 189.711C72.0489 190.559 71.5758 191.314 70.8631 191.787C70.1504 192.261 69.2718 192.42 68.4485 192.211L62.5994 190.724C61.1187 190.35 60.1602 188.924 60.3629 187.407C61.1309 181.736 62.5195 172.999 66.7835 161.497C67.318 160.053 68.8601 159.242 70.3531 159.63L76.1531 161.141C76.9703 161.356 77.6584 161.897 78.0516 162.64C78.4448 163.384 78.5124 164.262 78.2298 165.055C74.4574 175.715 72.8906 184.513 72.1656 189.711Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M118.019 80.7346C115.611 81.6132 115.611 83.0447 118.019 83.9233L124.477 86.2704C126.885 87.1489 130.823 87.1489 133.232 86.2704L177.561 70.1361C179.97 69.2575 179.97 67.826 177.561 66.9474L171.104 64.6004C168.695 63.7218 164.757 63.7218 162.348 64.6004L118.019 80.7346Z",
    fill: "#4D99FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M166.016 66.2891V74.3377",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M233.77 173.64C236.199 168.295 227.121 158.943 213.495 152.75C199.868 146.557 186.853 145.87 184.424 151.214C181.995 156.558 191.073 165.911 204.699 172.104C218.326 178.296 231.341 178.984 233.77 173.64Z",
    fill: "#4D99FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M204.705 172.12C200.76 170.326 197.203 168.274 194.192 166.123L216.256 154.1C228.323 160.237 236.033 168.686 233.772 173.662C231.345 179.008 218.326 178.319 204.705 172.126V172.12Z",
    fill: "#1E1D1D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M213.503 152.773C199.876 146.58 186.862 145.892 184.436 151.237L187.557 144.374C189.984 139.029 203.003 139.717 216.624 145.91C230.252 152.104 239.326 161.455 236.899 166.8L233.778 173.663C236.205 168.318 227.13 158.967 213.503 152.773Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M210.167 151.36C208.201 150.586 206.266 149.935 204.392 149.4L207.513 142.531C209.387 143.066 211.322 143.717 213.288 144.491L210.167 151.354V151.36Z",
    fill: "#4D99FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M201.658 148.694C196.945 147.612 192.761 147.354 189.652 147.944L192.773 141.081C195.882 140.485 200.066 140.749 204.779 141.831L201.658 148.7V148.694Z",
    fill: "#1E1D1D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M213.503 152.773C199.876 146.58 186.862 145.892 184.436 151.237L187.557 144.374C189.984 139.029 203.003 139.717 216.624 145.91C230.252 152.104 239.326 161.455 236.899 166.8L233.778 173.663C236.205 168.318 227.13 158.967 213.503 152.773Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1034 92.0384L46.2627 87.1232C42.7667 86.1033 37.2616 86.6194 34.0176 88.2721L55.2268 98.975",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1034 92.0384L46.2627 87.1232C42.7667 86.1033 37.2616 86.6194 34.0176 88.2721L55.2268 98.975",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8256 109.832L29.0962 93.6982C28.7644 92.2605 29.5693 90.534 30.8841 89.8643L34.0176 88.2669C35.5351 87.4927 37.9436 87.6279 39.369 88.5618L55.2268 98.9698C52.6708 99.4306 50.1395 100.106 47.6512 101.016C42.14 103.025 37.1817 106.017 32.8256 109.832Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M136.875 131.379L136.765 158.794L144.389 154.886C147.363 153.363 148.875 150.192 148.162 147.219L145.753 137.198C144.076 130.212 136.875 131.373 136.875 131.373V131.379Z",
    fill: "#9583FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M122.977 116.321L124.15 116.087C129.434 115.031 136.598 117.537 140.063 121.672L143.209 125.42C145.077 127.651 147.166 131.785 147.848 134.618L151.233 148.706C151.946 151.674 150.25 155.127 147.461 156.374",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M109.712 118.98C120.581 129.204 130.049 142.788 136.765 158.799L138.964 136.165C139.247 133.271 137.944 129.075 136.076 126.844L129.023 118.439C127.708 116.873 124.986 115.914 122.977 116.32L109.639 118.992",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M109.712 118.98C120.581 129.204 130.049 142.788 136.765 158.799L138.964 136.165C139.247 133.271 137.944 129.075 136.076 126.844L129.023 118.439C127.708 116.873 124.986 115.914 122.977 116.32L109.639 118.992",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M152.001 245.64C117.853 256.92 91.0525 248.22 80.2881 243.477C76.6816 241.886 72.6511 241.499 68.8049 242.383L52.8919 246.039C42.3364 242.002 28.242 226.237 23.3698 219.177C18.9707 212.806 14.4609 209.998 14.4609 209.998C23.2223 234.064 40.8127 252.472 62.409 262.327C86.85 273.484 96.1889 271.789 114.467 268.827C118.436 268.182 122.233 270.726 123.143 274.646L128.236 296.611L135.701 293.022L135.191 271.703C135.099 267.906 137.944 263.734 141.513 262.437L152.739 258.352C157.605 253.621 161.697 247.882 164.953 241.357L151.995 245.64H152.001Z",
    fill: "#9583FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M139.056 268.011L138.995 292.433C138.989 295.647 132.451 299.271 123.96 300.672C115.592 302.055 108.33 300.783 107.12 297.84L97.6885 274.874C97.6762 274.837 97.664 274.806 97.6578 274.769C97.3752 273.073 106.413 270.173 117.847 268.281C129.275 266.395 138.768 266.235 139.044 267.931C139.044 267.955 139.05 267.98 139.05 268.011H139.056Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91211 200.254L16.5015 191.83C20.575 187.837 26.7436 187.904 30.6573 189.33L43.7134 194.079C53.6237 197.686 62.3728 206.791 67.9516 221.752L70.8516 229.524C78.3535 249.646 80.8909 251.729 68.0253 254.457L47.1295 258.886",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5073 243.765C61.8315 248.428 59.1035 252.748 59.1035 252.748L77.0564 248.791C77.1424 247.187 76.6079 245.061 75.6003 242.149C73.3577 241.823 71.0537 241.897 68.8049 242.389L62.5073 243.765Z",
    fill: "#9583FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91211 200.254L16.5015 191.83C20.575 187.837 26.7436 187.904 30.6573 189.33L43.7134 194.079C53.6237 197.686 62.3728 206.791 67.9516 221.752L70.8516 229.524C78.3535 249.646 80.8909 251.729 68.0253 254.457L47.1295 258.886",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9867 201.936C45.7282 204.757 53.0457 212.48 56.8612 222.968C62.612 238.758 58.2559 254.843 47.1352 258.892C43.3996 260.249 39.3814 260.077 35.4677 258.658L22.4116 253.909C14.6701 251.089 7.35256 243.366 3.53712 232.878C-2.2137 217.088 2.14242 201.003 13.2631 196.954C16.9987 195.596 21.0169 195.768 24.9306 197.187L37.9867 201.936Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8467_88027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.232 218.573L17.5889 206.732V229.381L25.232 241.221V232.617L32.4917 243.868L43.5702 247.903L34.3984 233.691L25.2266 230.353V218.573H25.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5694 230.253C40.2715 229.395 40.6409 226.695 39.3944 224.223C38.1479 221.751 35.7576 220.443 34.0555 221.301C32.3535 222.16 31.9841 224.859 33.2306 227.331C34.4771 229.803 36.8674 231.111 38.5694 230.253Z",
    fill: "#9583FF"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.199 261.509C156.701 255.414 162.642 247.12 166.826 237.32",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M112.514 70.8235L143.246 59.6352C155.866 55.0456 168.811 53.227 181.431 53.8721",
    stroke: "#1E1D1D",
    strokeWidth: 0.614403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M128.502 54.4765C124.366 38.9171 129.322 20.0223 139.571 12.2717C142.887 9.7622 146.348 8.73331 149.657 9.00775L142.956 8.4528C139.647 8.17835 136.181 9.21094 132.87 11.7168C122.617 19.462 117.665 38.3621 121.801 53.9216C124.605 64.4584 130.852 70.7636 137.774 71.3408L144.475 71.8958C137.547 71.3222 131.301 65.0171 128.502 54.4765Z",
    fill: "#9583FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M128.501 54.4765C127.24 49.7306 126.828 44.6714 127.148 39.7198L120.448 39.0849C120.117 44.0675 120.525 49.154 121.792 53.9199C124.596 64.4567 130.842 70.7619 137.765 71.3391L144.465 71.8941C137.543 71.3168 131.291 65.0154 128.492 54.4748L128.501 54.4765Z",
    fill: "#1E1D1D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M139.571 12.2711C149.829 4.52217 161.495 10.8578 165.631 26.4173C169.771 41.9821 164.81 60.8805 154.561 68.6311C144.308 76.3764 132.642 70.0408 128.502 54.4759C124.366 38.9164 129.321 20.0217 139.571 12.2711Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M139.571 12.2711C149.829 4.52218 161.495 10.8578 165.631 26.4173C169.771 41.9821 164.81 60.8805 154.561 68.6311C144.308 76.3764 132.642 70.0408 128.502 54.4759C124.366 38.9164 129.321 20.0217 139.571 12.2711Z",
    stroke: "#1E1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M120.96 34.5502L127.651 35.1833C128.234 31.4802 129.23 27.9055 130.587 24.647L123.92 24.0135C122.554 27.2703 121.554 30.8396 120.956 34.5448L120.96 34.5502Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M128.502 54.4765C124.366 38.9171 129.322 20.0223 139.571 12.2717C142.887 9.7622 146.348 8.73331 149.657 9.00775L142.956 8.4528C139.647 8.17836 136.181 9.21094 132.87 11.7168C122.617 19.462 117.665 38.3621 121.801 53.9216C124.605 64.4584 130.852 70.7636 137.774 71.3408L144.475 71.8958C137.547 71.3222 131.301 65.0171 128.502 54.4765Z",
    stroke: "#1E1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.294 46.8379L152.529 43.1125L161 51.0008L150.765 54.7261L142.294 46.8379Z",
    fill: "#1E1D1D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137 27.7363L144.059 34.3099V57.1669L137 50.5933L137 27.7363Z",
    fill: "#1E1D1D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M157.824 32.4999C157.824 35.0246 156.243 37.6464 154.294 38.3558C152.345 39.0653 150.765 37.5938 150.765 35.0691C150.765 32.5444 152.345 29.9226 154.294 29.2131C156.243 28.5036 157.824 29.9752 157.824 32.4999Z",
    fill: "#1E1D1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8467_88027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9362,
    height: 21.5041,
    fill: "white",
    transform: "translate(181.021 77.707)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8467_88027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7183,
    height: 21.8666,
    fill: "white",
    transform: "translate(176.67 184.549) rotate(14.4383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8467_88027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3014,
    height: 28.453,
    fill: "white",
    transform: "translate(226.434 165.061) rotate(15.7046)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8467_88027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9813,
    height: 41.165,
    fill: "white",
    transform: "translate(17.5889 206.732)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboard2);
export default __webpack_public_path__ + "static/media/Onboard2.5e2aba486425935391774bea86784255.svg";
export { ForwardRef as ReactComponent };